/* eslint-disable camelcase */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { Typography, Box, Container, Grid, Card, Stack } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import axiosInstance from '../../utils/axiosInstance';
import SingleSelector from '../single-selector/singleSelector';

function TabPanel(props) {
  const { children, value, index } = props;

  return (
    <Box role="tabpanel" sx={{ display: value === index ? 'inline' : 'none' }}>
      <Box sx={{ p: 3 }}>{children}</Box>
    </Box>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function RecordEvent() {
  const { adaptorType } = window;
  const sensorList = useSelector((state) => state.app.sensorList);
  const [sensor, setSensor] = useState(null);
  const sensorRef = useRef();
  const { enqueueSnackbar } = useSnackbar();

  const [eventTimestamps, setEventTimestamps] = useState([]);
  const [recordTimelines, setRecordTimelines] = useState();

  const cleanup = () => {
    /**
     * clean arrays
     */
    setEventTimestamps([]);
    setRecordTimelines([]);
  };

  const handleSetSensor = (val) => {
    cleanup();
    setSensor(val);
    sensorRef.current = val;
  };

  const triggerEvent = () => {
    axiosInstance
      .post(
        `${window.location.protocol}//${sensor.host}/api/v1/record/${sensor.sensorId}/event`, {} , { headers: { "streamId": sensor.sensorId }}
      )
      .then((response) => {
        console.log("----trigger respnse----");
        console.log(response);
        const currentTime = new Date().toISOString();
        setEventTimestamps([...eventTimestamps, currentTime]);
      })
      .catch((error) => {
        console.log('Could not trigger record event', error);
        enqueueSnackbar(`Error - Could not trigger record event`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      });
  };

  const fetchRecordTimelines = () => {
    axiosInstance
      .get(`${window.location.protocol}//${sensor.host}/api/v1/record/${sensor.sensorId}/timelines` , { headers: { "streamId": sensor.sensorId } })
      .then((response) => {
        if (response.data) {
          setRecordTimelines(JSON.stringify(response.data, null, 2));
        }
        else {
          setRecordTimelines("null");
        }
      })
      .catch((error) => {
        console.error('unable to fetch timelines', error);
        enqueueSnackbar(`Error - Unable to fetch timelinest`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      });
  };

  return (
    <Container maxWidth="xl">
      <Typography variant="h4" sx={{ mb: 5 }}>
        Event based recording test
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Card>
            <Box sx={{ p: 3 }}>
              <Stack spacing={3} sx={{ mb: 2 }}>
                <SingleSelector
                  id="record-event"
                  placeholder="Type to search"
                  label={`Select ${adaptorType === "streamer" ? "file" : "sensor"}`}
                  value={sensor}
                  onChange={handleSetSensor}
                  getOptionLabel={(option) => {
                    if (option.remoteDeviceName && option.remoteDeviceLocation) {
                      return `${option.name} at ${option.remoteDeviceName} (${option.remoteDeviceLocation})`;
                    } if (option.remoteDeviceName) {
                      return `${option.name} at ${option.remoteDeviceName}`;
                    }
                    return option.name;

                  }}
                  options={sensorList}
                />
              </Stack>
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Card>
            <Box sx={{ p: 3 }}>
              <Box
                m={1}
                display="flex"
              >
                <LoadingButton
                  size="large"
                  type="submit"
                  variant="contained"
                  onClick={triggerEvent}
                >
                  Trigger Event
                </LoadingButton>
              </Box>
            </Box>
            <Box
              m={1}
              display="flex"
            >
              <TextareaAutosize
                value={eventTimestamps.join('\n')}
                cols="50"
                minRows="3"
                readOnly
              />
            </Box>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Card>
            <Box sx={{ p: 3 }}>
              <Box
                m={1}
                display="flex"
              >
                <LoadingButton
                  size="large"
                  type="submit"
                  variant="contained"
                  onClick={fetchRecordTimelines}
                >
                  Fetch Record Timelines
                </LoadingButton>
              </Box>
            </Box>
            <Box
              m={1}
              display="flex"
            >
              <TextareaAutosize
                value={recordTimelines}
                cols="50"
                minRows="3"
                readOnly
              />
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
